// Registre CENTRALISÉ des opérations facturables.
// Aucune donnée n'est créée ici : on lit les opérations existantes (facturier)
// et l'état réel de la souche officielle (emissions_officielles côté serveur).
import { fetchFacturier, fetchTiers } from './dataProvider';
import { fetchEmissions } from './emission';

// Opérations qui doivent obligatoirement porter une facture officielle.
export const OPERATIONS_OBLIGATOIRES = ['vente', 'prestation_reception', 'emballages_reception', 'facture_libre'];

export const ETATS_FACTURATION = ['Tous', 'À facturer', 'Facturée', 'À corriger', 'Annulée'];

const blocages = (r, mfClient) => {
  const liste = [];
  if (!r.tiersId) liste.push('Client non rattaché à une fiche contact');
  if (!(Number(r.montant) > 0)) liste.push('Montant nul ou non calculé');
  if (!r.date) liste.push('Date de l’opération manquante');
  if (!(r.lignes ?? []).length) liste.push('Aucun détail de ligne');
  return { blocages: liste, avertissements: mfClient ? [] : ['Matricule fiscal du client absent'] };
};

// Index partagé (mis en cache) pour afficher l'état de facturation depuis
// n'importe quel écran métier : Ventes, Réception, Trituration…
let cacheIndex = null;
export const indexEmissions = () => {
  if (!cacheIndex)
    cacheIndex = fetchEmissions().then(
      (es) => new Map(es.filter((e) => e.type_document === 'facture').map((e) => [`${e.operation_type}:${e.operation_id}`, e]))
    );
  return cacheIndex;
};
export const invaliderIndexEmissions = () => {
  cacheIndex = null;
};

export async function fetchOperationsFacturables() {
  cacheIndex = null;
  const [lignes, emissions, tiers] = await Promise.all([fetchFacturier(), fetchEmissions(), fetchTiers()]);
  const factures = new Map(
    emissions.filter((e) => e.type_document === 'facture').map((e) => [`${e.operation_type}:${e.operation_id}`, e])
  );
  const mfParTiers = new Map(tiers.map((t) => [t.id, String(t.mf || '').trim()]));

  return lignes
    .filter((r) => r.operationType)
    .map((r) => {
      const mfClient = r.tiersId ? mfParTiers.get(r.tiersId) : '';
      const facture = factures.get(`${r.operationType}:${r.ref}`) ?? null;
      const { blocages: bloc, avertissements } = blocages(r, mfClient);
      const etat = facture
        ? facture.annulee_par
          ? 'Annulée'
          : 'Facturée'
        : bloc.length
          ? 'À corriger'
          : 'À facturer';
      return {
        ...r,
        mfClient,
        facture,
        numeroOfficiel: facture?.numero ?? null,
        obligatoire: OPERATIONS_OBLIGATOIRES.includes(r.operationType),
        blocages: bloc,
        avertissements,
        etatFacturation: etat,
        reglement: r.statut,
      };
    });
}

export const filtrerOperations = (rows, { q = '', du = '', au = '', client = 'Tous', module = 'Tous', etat = 'Tous' }) => {
  const t = q.trim().toLowerCase();
  return rows.filter(
    (r) =>
      (!t || [r.tiers, r.ref, r.numeroOfficiel, r.categorie, r.source].some((v) => String(v ?? '').toLowerCase().includes(t))) &&
      (!du || String(r.date) >= du) &&
      (!au || String(r.date) <= au) &&
      (client === 'Tous' || r.tiers === client) &&
      (module === 'Tous' || r.source === module) &&
      (etat === 'Tous' || r.etatFacturation === etat)
  );
};
